import { getToken } from "./auth.service";

export const getHeaders = () => {
  const token = getToken();

  if (token) {
    return {'Authorization': `MHH ${token}`}
  }

  return {};
}



// WEBPACK FOOTER //
// ./src/services/index.js